import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('search');

const SEARCH = define('SEARCH', true);
const REPLACE = define('REPLACE', true);

const initialState = {
  results: [],
  isCaseSensitive: false,
  isRegex: false,
  isStripLink: false,
  searching: false,
  replacing: false,
  keyword: '',
  replaceText: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH.PENDING:
      return {
        ...state,
        searching: true,
        keyword: action.keyword,
        isCaseSensitive: action.isCaseSensitive,
        isRegex: action.isRegex,
        isStripLink: action.isStripLink,
      };
    case SEARCH.RESOLVED:
      return {
        ...state,
        results: action.data,
        searching: false
      };
    case SEARCH.REJECTED:
      return {
        ...state,
        searching: false,
      };
    case REPLACE.PENDING:
      return {
        ...state,
        replacing: true,
        replaceText: action.replaceText,
        isCaseSensitive: action.isCaseSensitive,
        isRegex: action.isRegex,
        isStripLink: action.isStripLink,
      };
    case REPLACE.RESOLVED:
      return {
        ...state,
        replacing: false,
        results: [],
      };
    case REPLACE.REJECTED:
      return {
        ...state,
        replacing: false
      };
    default:
      return state;
  }
};

export const actions = {
  search: (keyword, isCaseSensitive, isRegex, isStripLink) => ({
    type: SEARCH,
    promise: api.post(`/info/search?is_case_sensitive=${isCaseSensitive ? 'true' : 'false'}&is_regex=${isRegex ? 'true' : 'false'}&is_strip_link=${isStripLink ? 'true' : 'false'}`, { keyword }),
    success: 'Search done',
    error: 'Search fail',
  }),
  replace: (keyword, replaceText, locations, isCaseSensitive, isRegex, isStripLink) => ({
    type: REPLACE,
    promise: api.post(`/info/replace?is_case_sensitive=${isCaseSensitive ? 'true' : 'false'}&is_regex=${isRegex ? 'true' : 'false'}&is_strip_link=${isStripLink ? 'true' : 'false'}`, { keyword, replace_text: replaceText, locations }),
    success: 'Replace done',
    error: 'Replace fail',
  })
};



// WEBPACK FOOTER //
// ./src/ducks/replace.js